import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getEquipamentos, getUnidadeDeMedida } from './services'
import { TTipoMonitoria, TEquipamento } from './types'

const initialState = {
  status: "",
  dataEquipamentos: [] as Array<TEquipamento>,
  dataUnidadeDeMedida: [] as Array<string>
}

export const actionGetEquipamentos = createAsyncThunk<Array<TEquipamento>, TTipoMonitoria>(
  "ACTION_GET_EQUIPAMENTOS",
  async (tipoMonitoria) => {
    const result = await getEquipamentos(tipoMonitoria)
    return result
  }
)

export const actionGetUnidadeDeMedida = createAsyncThunk<Array<string>>(
  "ACTION_GET_UNIDADE_MEDIDA",
  async () => {
    const result = await getUnidadeDeMedida()
    return result
  }
)

const sliceGetEquipamentos = createSlice({
  name: "GET_EQUIPAMENTOS",
  initialState,
  reducers: {},
  extraReducers: {
    [`${actionGetEquipamentos.pending}`]: (state) => {
      state.status = "loading"
    },
    [`${actionGetEquipamentos.fulfilled}`]: (state, { payload }) => {
      state.status = "success"
      state.dataEquipamentos = payload
    },
    [`${actionGetEquipamentos.rejected}`]: (state) => {
      state.status = "error"
    },
    [`${actionGetUnidadeDeMedida.pending}`]: (state) => {
      state.status = "loading"
    },
    [`${actionGetUnidadeDeMedida.fulfilled}`]: (state, { payload }) => {
      state.status = "success"
      state.dataUnidadeDeMedida = payload
    },
    [`${actionGetUnidadeDeMedida.rejected}`]: (state) => {
      state.status = "error"
    },
  }
})

export default sliceGetEquipamentos.reducer